import React, { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { MultiAirline } from 'pcln-icons'
import { Box, Tooltip } from 'pcln-design-system'

const StyledMultipleAirlineTooltip = styled(Tooltip)`
  width: 220px;
`

const MultipleAirlinesIconWithTooltip = ({ multipleAirlineText }) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false)

  return (
    <Box
      data-testid='multiple-airlines-icon-with-tooltip'
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => {
        setTooltipVisible(false)
      }}
    >
      {isTooltipVisible && (
        <StyledMultipleAirlineTooltip bg='background.darkest' color='text.lightest' zIndex={1} top center>
          {multipleAirlineText}
        </StyledMultipleAirlineTooltip>
      )}
      <MultiAirline color='text.base' size={30} />
    </Box>
  )
}

MultipleAirlinesIconWithTooltip.propTypes = {
  multipleAirlineText: PropTypes.string.isRequired,
}
export default MultipleAirlinesIconWithTooltip
